import { FC, FunctionComponent, useEffect, useRef, useState } from "react";
import { LoginButton, FormText, FormHeading, Loading } from "../Styles";
import SixBoxGrid from "./SixBoxGrid";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { FormData } from "../../data/interfaces/dataMessage";
import {UserData, NewUserData} from "../../data/interfaces/userInfo";
import FadeLoader from "react-spinners/PulseLoader";
import useHover from "./useHover";

interface myProps {
  register: UseFormRegister<FormData>;
  errors: any;
  phoneNumber: string;
  setFormData: UseFormSetValue<FormData>;
  user: NewUserData;
  validMFA: Boolean;
  changeForm:React.Dispatch<React.SetStateAction<string>>;
  loginPaused: boolean
}

const MFACheck: FC<myProps> = (props) => {

  const [resendCooldown, setresendCooldown] = useState(60);
  const [isCooldown, setisCooldown] = useState(false);
  const [codeLength, setCodeLength] = useState(0);
  const loginButtonRef = useRef<HTMLButtonElement>(null);
  const { isHovered, handleMouseEnter, handleMouseLeave } = useHover();

  const onMFAArticleClick= () => {
    const url = "https://helpme.everlogic.com/help/edit-user-mfa-information-multi-factor-authentication";
    window.open(url, "_blank");
  };

  const handleCodeChange = (length: number) => {
    setCodeLength(length);
  };

  useEffect(() => {
    if (codeLength === 6) {
      if (loginButtonRef.current) {
        loginButtonRef.current.click();
      }
    }
  }, [codeLength]);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (isCooldown) {
      intervalId = setInterval(() => {
        setresendCooldown((prevCount) => prevCount - 1);
      }, 1000);
    }

    if (resendCooldown === 0) {
      setisCooldown(false);
    }

    return () => {
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
    };
  }, [isCooldown, resendCooldown]);

  useEffect(() => {
    if (props.user.userId){
      props.setFormData("UserId", props.user.userId)
    }
    if(props.user.workstationId){
      props.setFormData("WorkstationId", props.user.workstationId)
    }
  });

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const onResend = () => {

    if (!isCooldown) {
      props.changeForm("SendCode")
      setisCooldown(true)
      setresendCooldown(60)
    }
  }

  return (<>
    <FormText>
      <FormHeading>Please enter your verification code</FormHeading>
    </FormText>
    <div style={{display: "flex", justifyContent: "center", height: '240px'}}>
      <div className="input-container">
        <SixBoxGrid setFormData={props.setFormData} register={props.register} errors={props.errors} onCodeChange={handleCodeChange}/>
        <b style={{ display:'flex', color: "grey", fontSize:"13px"}}>
          <a 
            onMouseEnter={() => handleMouseEnter('resend')}
            onMouseLeave={handleMouseLeave} 
            onClick={onResend} 
            style={{ 
              display: "flex",
              width: 'fit-content', 
              fontSize: "13px",
              cursor: "pointer", 
              textDecoration:  isHovered === 'resend' ? 'underline' : 'none',
              color: '#03a12b',
              transition: "color 0.2s"}}>Resend code
          </a>
        </b>
          {isCooldown &&<span>{resendCooldown}</span>}

        <br />

        <LoginButton
          ref={loginButtonRef}
          style={{display:"none"}}
          variant='contained'
          size='large'
          type="submit"
          disableElevation
          disabled = {props.loginPaused ? true : false}
        >
          Verify
          {props.loginPaused && (<Loading><FadeLoader color={"white"} size={7} /></Loading>)}
        </LoginButton>

        <b style={{ paddingTop: '115px', display: "flex", fontSize: "12px", color:'#616161'}}>Need help? Read 
          <a 
            onMouseEnter={() => handleMouseEnter('editMFA')}
            onMouseLeave={handleMouseLeave}
            style={{
                display: "flex",
                fontSize: "12px",
                paddingLeft: "5px",
                paddingRight: "5px",
                width: 'fit-content',  
                cursor: "pointer",
                textDecoration:  isHovered === 'editMFA' ? 'underline' : 'none',
                color: '#03a12b',
                transition: "color 0.2s"}} 
            onClick={onMFAArticleClick}> MFA article 
            </a> or call (904) 998-4066</b>
      </div>
    </div>

  </>);
}

export default MFACheck;